<app-header [showFindParking]="false"></app-header>
<div class="map-header">
    <div class="container-fluid">
        <div class="row">
            <div class="col-xl-5 col-lg-4 col-md-4 d-none d-lg-inline-block">
                <h3 class="d-inline-block p-2 mt-1">Over 13 000 Parking Bays in South Africa</h3>
                <!--                <h3 *ngIf="parkings && parkings.length > 0" class="d-inline-block p-2 mt-1">{{ parkings.length }} Parkings Found</h3>-->
            </div>
            <div class="col-xl-7 col-lg-8 col-md-12 p-0">
                <form class="">
                    <!-- <div class="d-block d-md-inline-block">
                        <div *ngIf="true" class="d-block dropdown d-md-inline-block me-3">
                            <a
                                class="btn btn-outline-primary dropdown-toggle d-block d-md-inline-block mb-3 mb-md-0"
                                href="#"
                                role="button"
                                id="dropdownType"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                <span *ngIf="!selectedType">Any Type</span>
                                <span *ngIf="selectedType">{{ prettyType(selectedType) }}</span>
                            </a>
                            <ul class="dropdown-menu" aria-labelledby="dropdownType">
                                <li><a class="dropdown-item" href="" (click)="onTypeChange(parkingTypes.STANDARD)">ParkUpp Monthly</a></li>
                                <li><a class="dropdown-item" href="" (click)="onTypeChange(parkingTypes.PARKING_COLLECTOR)">ParkUpp Collector</a></li>
                                <li><a class="dropdown-item" href="" (click)="onTypeChange(parkingTypes.FLEX)">ParkUpp Flex</a></li>
                                <li><a class="dropdown-item" href="" (click)="onTypeChange(parkingTypes.TRUCKS)">Trucks</a></li>
                                <li><a class="dropdown-item" href="" (click)="onTypeChange(parkingTypes.PLANES_TRAINS_SHIPS)">Planes Trains Ships</a></li>
                                <li><a class="dropdown-item" href="" (click)="onTypeChange(parkingTypes.TRAILERS_CARAVANS_BOATS)">Trailers Caravans Boats</a></li>
                            </ul>
                        </div>
                    </div> -->
                    <!-- <div *ngIf="false" class="btn-group" role="group" aria-label="Term">
                        <button (click)="onTermSelected(terms.DAILY)" type="button" class="btn btn-outline-primary" [ngClass]="{ active: term == 'DAILY' }">Daily</button>
                        <button (click)="onTermSelected(terms.MONTHLY)" type="button" class="btn btn-outline-primary" [ngClass]="{ active: term == 'MONTHLY' }">Monthly</button>
                    </div> -->
                    <div class="d-none d-md-inline-block search-input-container">
                        <input type="text" placeholder="Search by Town or City" name="geo-search" id="geo-search" class="form-control search-input me-3" />
                    </div>

                    <div class="d-block d-md-none">
                        <div class="row">
                            <div class="col-7 pe-0">
                                <input type="text" placeholder="Search by Town or City" name="geo-search-mobile" id="geo-search-mobile" class="form-control search-input d-block" style="width: 100%" />
                            </div>
                            <div class="col-5">
                                <a (click)="onToggleMap()" type="button" class="btn btn-outline-primary ms-2 d-block">
                                    <span *ngIf="!showMap">View Map</span>
                                    <span *ngIf="showMap">View List</span>
                                </a>
                            </div>
                        </div>
                        <!-- <div class="row">
                            <ng-container *ngIf="parkings && parkings.length > 0"> {{ parkings.length }} Parkings Found </ng-container>
                            <ng-container *ngIf="!parkings || parkings.length == 0"> No Parkings Found </ng-container>
                        </div> -->
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
<div class="container-fluid map-search-background">
    <div class="row">
        <div class="col-md-5">
            <div class="no-parkings-message p-4" *ngIf="parkings && parkings.length == 0">
                <div>No parking available in this area. Zoom out on the map to find parkings nearest to this location.</div>
            </div>
            <div class="results-list" id="results-list" [ngClass]="{ 'mobile-results-list': hideNavigation }" (scroll)="onWindowScroll($event)">
                <div class="results-list-item" *ngFor="let parking of parkings">
                    <app-parking-list-item
                        id="list-item-{{ parking.$key }}"
                        [highlighted]="parking.$key == parkingKeyHighlighted"
                        [merchantKey]="parking.merchantRef.id"
                        [parking]="parking"
                        (onSelect)="onSelect($event)"
                        (onHover)="onHover($event)"
                    ></app-parking-list-item>
                </div>
            </div>
        </div>
        <div class="col-md-7 search-map-container px-0" [ngClass]="{ show: showMap }">
            <app-google-map
                [parkingType]="selectedType"
                [onlyCity]="true"
                [showPriceAsMarker]="true"
                [autoCompleteInputElement]="autoCompleteInputElement"
                [scrollWheel]="true"
                [zoom]="zoom"
                (onLocationChanged)="onChangeLocation($event)"
                (onBoundsChanged)="onBoundsChange($event)"
                (onMarkerSelected)="onParkingMarkerSelected($event)"
                [mapHeight]="'100%'"
            ></app-google-map>
        </div>
    </div>
</div>
